// Kiosk scan suppression rule, kept out of the component so it can be tested.
//
// The camera decoder fires about ten times a second, so a badge left in front
// of the lens is read over and over. Without suppression the second read would
// reach the backend and be taken as a clock-OUT. So a badge that has just been
// clocked is remembered and ignored for a while.
//
// The rule only applies to a scan that WORKED. A scan that was refused (the
// office-network 403, the rate-limit 429, a network drop) must be allowed
// straight away, otherwise the same person waves the same badge, nothing
// happens and no message appears for half a minute.

// If the identical decoded text is re-scanned inside this window after a
// successful scan, ignore it silently.
export const SAME_QR_SUPPRESS_MS = 30000;

/**
 * Decide whether to ignore a scan.
 *
 * @param {{text: string, at: number}|null} prev  the remembered scan
 * @param {number} now  current timestamp, milliseconds
 * @param {string} text  decoded text of the scan just received
 * @param {boolean} lastWasSuccess  whether the remembered scan succeeded
 * @returns {boolean} true to ignore this scan silently
 */
export function shouldSuppressScan(prev, now, text, lastWasSuccess) {
  if (!lastWasSuccess) return false;
  if (!prev || !prev.text || !text) return false;
  if (prev.text !== text) return false;

  const at = Number(prev.at);
  if (!Number.isFinite(at)) return false;

  const elapsed = now - at;
  // A clock that moved backwards must not lock the kiosk out: let the scan in.
  if (elapsed < 0) return false;

  return elapsed < SAME_QR_SUPPRESS_MS;
}
